import { RouteObject } from 'react-router-dom';

import { UserProfile } from './UserProfile';

export const userProfileRoute: RouteObject = {
  path: 'user-profile',
  element: <UserProfile />,
};
